/**
 * Classifying an automation row by its stored type.
 */

/**
 * Whether a row is an alert.
 *
 * **Reads `automation_type`, not `type`.** `AutomationResponse` has no `type`
 * field — its `Config` sets only `from_attributes`, with no alias — so
 * `automation.type` is always undefined. Keying on it meant every alert failed
 * this test, opened the run-history drawer instead of its modal, and showed the
 * generic Active/Paused pill.
 *
 * Both spellings are accepted, mirroring `services/alerts/scheduled.is_alert`:
 * the create path takes either and the column is free text, not an enum.
 *
 * Keyed on the type rather than on the presence of alert columns, because
 * `AutomationResponse` returns all eight alert fields on every automation and
 * they are null on non-alert rows.
 */
export const isAlert = (automation) => (
  ['alert', 'alerts'].includes(String(automation?.automation_type || '').trim().toLowerCase())
);

export default isAlert;
